module.exports = __webpack_public_path__ + "static/media/content-01-m.d817dcc6.png";